<div class="w-full relative  bg-white border border-gray-300 rounded-lg">
    <div class="w-full text-xs py-1 leading-3" *ngIf="user != null || customer != null || cooperation != null">
        <div *ngIf="user != null" class="text-blue-400 inline-block mx-1 relative pl-1 pr-6 py-1 border border-blue-400 rounded-lg">
            #{{ user.username }}
            <div (click)="user = null" class="absolute right-0 vertical-center mr-2 text-2xs cursor-pointer" title="Entfernen">
                <span class="iconify" data-icon="fa:times"></span>
            </div>
        </div>
        <div *ngIf="customer != null" class="text-green-400 inline-block mx-1 py-1 relative pl-1 pr-6 border border-green-400 rounded-lg">
            #{{ customer.companyDisplayName }}
            <div (click)="customer = null" class="absolute right-0 vertical-center mr-2 text-2xs cursor-pointer" title="Entfernen">
                <span class="iconify" data-icon="fa:times"></span>
            </div>
        </div>
        <div *ngIf="cooperation != null" class="text-orange-600 inline-block mx-1 py-1 relative pl-1 pr-6 border border-orange-600 rounded-lg">
            #{{ cooperation.name }}
            <div (click)="cooperation = null" class="absolute right-0 vertical-center mr-2 text-2xs cursor-pointer" title="Entfernen">
                <span class="iconify" data-icon="fa:times"></span>
            </div>
        </div>
    </div>
    <div class="overflow-hidden pl-8 relative">
        <div class="absolute left-0 ml-2 vertical-center text-gray-400 text-xl">
            <span class="iconify" data-icon="carbon:task-settings"></span>
        </div>
        <div class="w-full bg-white pr-8">
            <input class="styled" (focus)="onFocus($event)" (blur)="blur($event)" #taskInput (keydown)="keyDown($event)" [placeholder]="placeholderText" type="text" [(ngModel)]="taskText" />
        </div>
    </div>

    <div class="absolute inset-0 rounded-sm bg-white rounded-lg border border-gray-300 overflow-hidden" *ngIf="searchOpened">
        <div class="w-full h-full pl-8 relative">
            <div class="vertical-center left-0 ml-2 text-xl text-gray-400">
                <span class="iconify inline" data-icon="carbon:search"></span>
            </div>
            <div class="vertical-center w-full left-0 ml-2 pl-8">{{ query$ | async }}</div>
            <div class="vertical-center w-full text-gray-400 ml-2" *ngIf="(query$ | async) == ''">
                <em>Suche nach Unternehmen, Artists, Kooperationen</em>
            </div>
        </div>
    </div>

    <div *ngIf="searchOpened" class="suggestion-container">
        <ul>
            <li *ngFor="let result of (results$ | async); index as i" (click)="selectedIndex = i;saveSelection()" [class.active]="selectedIndex == i">
                {{ result.label }}<br>
                <div class="text-xs text-gray-600" *ngIf="result.description">{{ result.description }}</div>
                <div class="text-2xs">
                    <span *ngIf="result.type == 'customer'">Kunde</span>
                    <span *ngIf="result.type == 'cooperation'">Kooperation</span>
                    <span *ngIf="result.type == 'user'">Artist</span>
                </div>
            </li>
            <li>
                <div (click)="addCustomer()" class="p-2 cursor-pointer font-bold hover:underline text-primary" *ngIf="!matchInType('customer')">
                    + Unternehmen erstellen
                </div>
            </li>
        </ul>
    </div>
</div>
